import './Notifications.scss';

import type { FC, ReactNode } from 'react';
import { useReactiveVar } from '@apollo/client';
import { TransitionGroup, CSSTransition } from 'react-transition-group';
import classNames from 'classnames';

import * as state from 'state';

const Notifications: FC = () => {
  const notifications = useReactiveVar(state.notifications);

  return (
    <TransitionGroup className="Notifications">
      {notifications.map((notification) => (
        <NotificationFade key={notification.id}>
          <div
            className={classNames(
              'Notifications-message',
              `Notifications-message--${notification.type}`,
            )}
          >
            {notification.content}
          </div>
        </NotificationFade>
      ))}
    </TransitionGroup>
  );
};

const NotificationFade: FC<{ children: ReactNode }> = ({
  children,
  ...props
}) => (
  <CSSTransition
    {...props}
    timeout={400}
    classNames={{
      enter: 'Notifications-message--enter',
      enterActive: 'Notifications-message--enterActive',
      exit: 'Notifications-message--exit',
      exitActive: 'Notifications-message--exitActive',
    }}
  >
    {children}
  </CSSTransition>
);

Notifications.displayName = 'Notifications';

export default Notifications;
